import { useEffect, useState } from "react";
import useDataBean from "../../core/services/dataBean/useDataBean";
import { _RecordDocumentTRD, _single } from "../../core/services/dataBean/EntityCatalog";
import { toast } from "react-toastify";
import usePaginator from "../theme/Component/usePaginator";
import { MultipleFileInput } from "../theme/Component/MultipleFileInput";

interface Props {
    documents: any | null;
    idRecordProcess: number | null;
    idProcessType?: number | null;
    onChange:any;
}
export const AddDocumenExp = ({ documents, idRecordProcess, idProcessType = null,onChange }: Props) => {


    const _records = useDataBean(_RecordDocumentTRD);
    const [lista, setLista] = useState<any>([]);
    const [bean, setBean] = useState<any>({});
    const [process, setProcess] = useState<number | null>(idProcessType);
    const paginador = usePaginator();

    useEffect(() => {
        if (!documents) {
            getListaAllDocuments();
        }
    }, [documents])

    useEffect(() => {
        getListaAllDocuments();
    }, [paginador.page, process])

    const getListaAllDocuments = () => {
        _records.instance.getHiringModalityDocumentRender(paginador.page, 15, { ProcessType: process }).then((resp: any) => {
            if (resp.List) {
                setLista(resp.List);
                paginador.setPage(resp.NumberOfPages);
            }
        }).catch(err => toast.warning(err))
    }


    const saveRecordDocumentTRD = (bean) => {
        let doc = {
            IDRecordProcess:idRecordProcess,
            Name:`(${bean.TRDName ?? ''}) ${bean.Name}`,
            IDLnTRD:bean.IDLnTrd,
            Media:bean.Media,
            MediaContext:bean.MediaContext,
            State:1,            
            IDEmployee:_single.getAccountID(),
            LastUpdate:_single.getCurrenDate()
        };
        console.log(doc);
        
        return _RecordDocumentTRD.updateRecordDocumentTRD(doc).then(
            (resp:any)=>{
                return resp;
            }
        ).catch(err => {
            toast.error(String(err));
        });
    }

    const setListDocument = async (data:any) => {
        console.log(data);
        
        let lastResp = null;
        if(Array.isArray(data)){
            for (const item of data) {
                if(item) {
                    lastResp = await saveRecordDocumentTRD(item);
                }
            }
        }
        else {
            lastResp = await saveRecordDocumentTRD(data);
        }

        if (lastResp && onChange) {
            onChange(lastResp);
        }
    }

    return (
        <div className="row">
            <div className="col-md-12">
                
                <MultipleFileInput autoUpload label="" directory="expediente" onCreate={setListDocument} />
                
            </div>
          

        </div>
    )
}